import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Faq from '../Components/Faq/Faq'

function FaqLayout() {
  return (
    <>
    <Header />
    <Faq />
    <Footer />
    </>
  )
}

export default FaqLayout